const state = {
  pageSet: {},
  components: [],
  suspComps: [],
  floorNavComps: [],
  id: 0,
  head: {}
}
const mutations = {
  setPageSet (state, pageSet) {
    state.pageSet = pageSet
  },
  setComponents (state, components) {
    state.components = components
  },
  setSuspComps (state, suspComps) {
    state.suspComps = suspComps || []
  },
  setFloorNavComps (state, floorNavComps) {
    state.floorNavComps = floorNavComps
  },
  setId (state, id) {
    state.id = id
  },
  setHead (state, head) {
    state.head = head
  }
}
const actions = {}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
